import React from 'react';
import { Box, TextField, IconButton, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Question } from '../../../../types/course';

interface MatchingEditorProps {
    question: Question;
    onChange: (updatedQuestion: Question) => void;
}

const MatchingEditor: React.FC<MatchingEditorProps> = ({ question, onChange }) => {
    const pairs = question.pairs || [];

    const handlePairChange = (index: number, field: 'left' | 'right', value: string) => {
        const newPairs = [...pairs];
        newPairs[index] = { ...newPairs[index], [field]: value };
        onChange({ ...question, pairs: newPairs });
    };

    const handleAddPair = () => {
        onChange({ ...question, pairs: [...pairs, { left: '', right: '' }] });
    };

    const handleRemovePair = (index: number) => {
        const newPairs = [...pairs];
        newPairs.splice(index, 1);
        onChange({ ...question, pairs: newPairs });
    };

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>Matching Pairs:</Typography>
            {pairs.map((pair, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                    <Box sx={{ flex: 5 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Left Item"
                            value={pair.left}
                            onChange={(e) => handlePairChange(index, 'left', e.target.value)}
                        />
                    </Box>
                    <Box sx={{ flex: 0.5, textAlign: 'center' }}>→</Box>
                    <Box sx={{ flex: 5 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Right Item"
                            value={pair.right}
                            onChange={(e) => handlePairChange(index, 'right', e.target.value)}
                        />
                    </Box>
                    <Box sx={{ flex: 0.5 }}>
                        <IconButton
                            size="small"
                            onClick={() => handleRemovePair(index)}
                            color="error"
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            ))}

            <Button
                startIcon={<AddCircleOutlineIcon />}
                onClick={handleAddPair}
                size="small"
                sx={{ mt: 1 }}
            >
                Add Pair
            </Button>
        </Box>
    );
};

export default MatchingEditor;
